import React, { useState } from 'react';
import './Controls.css';

const TIME_RANGES = [
  { value: '10m', label: '10m' },
  { value: '1h', label: '1h' },
  { value: '4h', label: '4h' },
  { value: '24h', label: '24h' }
];

const TIME_UNITS = [
  { value: 'm', label: 'minutes' },
  { value: 'h', label: 'hours' }
];

const Controls = ({
  symbols,
  selectedSymbol,
  selectedTimeRange,
  onSymbolChange,
  onTimeRangeChange,
  onRefresh,
  loading
}) => {
  const [customTime, setCustomTime] = useState('');
  const [customTimeUnit, setCustomTimeUnit] = useState('m');

  const handleCustomTimeSubmit = () => {
    if (customTime && !isNaN(customTime)) {
      onTimeRangeChange(`${customTime}${customTimeUnit}`);
    }
  };

  const handleCustomTimeChange = (e) => {
    const value = e.target.value;
    if (value === '' || (!isNaN(value) && value >= 0 && value <= 999)) {
      setCustomTime(value);
    }
  };

  return (
    <div className="controls card">
      <div className="controls-row">
        <div className="controls-section">
          {/* Trading Pair Selection */}
          <div className="control-group trading-pair">
            <label htmlFor="symbol-select">SYMBOL</label>
            <select
              id="symbol-select"
              className="select"
              value={selectedSymbol}
              onChange={(e) => onSymbolChange(e.target.value)}
              disabled={loading}
            >
              {symbols.map(symbol => (
                <option key={symbol} value={symbol}>
                  {symbol}
                </option>
              ))}
            </select>
          </div>

          {/* Time Range Controls */}
          <div className="control-group time-range">
            <label>Time Range</label>
            <div className="time-controls">
              <div className="time-range-buttons">
                {TIME_RANGES.map(range => (
                  <button
                    key={range.value}
                    className={`button ${selectedTimeRange === range.value ? 'active' : ''}`}
                    onClick={() => onTimeRangeChange(range.value)}
                    disabled={loading}
                  >
                    {range.label}
                  </button>
                ))}
              </div>
              <div className="custom-time-controls">
                <input
                  type="number"
                  min="0"
                  max="999"
                  value={customTime}
                  onChange={handleCustomTimeChange}
                  placeholder="Custom"
                  className="select custom-time-input"
                  disabled={loading}
                  style={{ width: '150px', cursor: 'text' }}
                  />
                <select
                  value={customTimeUnit}
                  onChange={(e) => setCustomTimeUnit(e.target.value)}
                  className="select custom-time-unit"
                  disabled={loading}
                >
                  {TIME_UNITS.map(unit => (
                    <option key={unit.value} value={unit.value}>
                      {unit.label}
                    </option>
                  ))}
                </select>
                <button
                  className="button custom-time-apply"
                  onClick={handleCustomTimeSubmit}
                  disabled={loading || !customTime}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>

          {/* Refresh Button */}
          <div className="control-group actions">
            <label>&nbsp;</label>
            <button
              className="button secondary"
              onClick={onRefresh}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Loading...
                </>
              ) : (
                'Refresh'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Controls; 